import $ from 'jquery';

const $tooltip_wrapp = $('.tooltip_wrapp');
const $tooltip = $('.tooltip');

function clickTooltip() {
  const position = $(this).position().left;
  const width = $(this).find('.tooltip').width();
  const doc = window.innerWidth / 2;
  const link = $(this).attr('data-id');
  const elPosition = position + width;

  $(link).toggleClass('show');

  if(elPosition > doc) {
  	$(this).find('.tooltip').css('left', `${-position + 20}px`);
  }
}

$tooltip_wrapp.on('click', clickTooltip)

